<div class="content-full">
    <div class="row">
        <div class="col-sm-12 auto-fill">
            <div class="col-sm-12 col-no-gutters">
                <div class="box-content">
                    <div class="main">
                        <div class="row intake-header">
                            <div class="col-sm-12">
                                <div class="intake-header-title pull-left">
                                    <h2 class="mt-2">
                                        <span class="break"></span>
                                        Signature Requests
                                        <kno2-info-popover content="View sent signature requests and manage those saved as drafts." />
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div
                    class="col-sm-12 release-grid"
                    style="margin-top: -15px">
                    <div class="container row flex-column align-items-end">
                        <div class="btn-group release-dropdown">
                            <button
                                class="btn btn-info"
                                type="button"
                                routerLink="/signatures/new"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="New Request">
                                &nbsp; New Request &nbsp;
                                <i class="fa fa-upload"></i>
                            </button>
                        </div>
                    </div>
                    <ul class="nav nav-tabs">
                        <li
                            class="nav-item"
                            (click)="activeTab.set('events')"
                            [class.active]="activeTab() === 'events'">
                            <a
                                kno2NoOpLink
                                class="nav-link">
                                <div class="grid-icon"><i class="fa fa-upload"></i></div>
                                Sent
                                <kno2-info-popover
                                    class="ms-2"
                                    content="Sent includes all of the most recent sent activity and the delivery status of each signature request." />
                            </a>
                        </li>
                        <li
                            class="nav-item"
                            (click)="activeTab.set('drafts')"
                            [class.active]="activeTab() === 'drafts'">
                            <a
                                kno2NoOpLink
                                class="nav-link">
                                <div class="grid-icon"><i class="fa fa-file"></i></div>
                                Drafts
                                <kno2-info-popover
                                    class="ms-2"
                                    content="Drafts includes all of your organization's signature request drafts and allows you to edit and complete them." />
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        @if (activeTab() === "events") {
                            <kno2-signatures-history />
                        } @else if (activeTab() === "drafts") {
                            <kno2-signatures-drafts />
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
